import { api } from '../api';
import type {
  CreateInstalledPackagePayload,
  InstalledPackage,
} from '../api/installed-packages';

export class InstalledPackageService {
  async list(): Promise<InstalledPackage[]> {
    return await api.installedPackages.list();
  }

  async create(
    payload: CreateInstalledPackagePayload
  ): Promise<InstalledPackage> {
    return await api.installedPackages.create(payload);
  }

  async remove(id: number): Promise<void> {
    await api.installedPackages.remove(id);
  }
}

export const installedPackageService = new InstalledPackageService();
